import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z", fill: "currentColor" }));
export default SvgPlus;
